import { ShipmentDetailsPage } from './ShipmentDetailsPage'

export default ShipmentDetailsPage
